import React from 'react';
import theme from '../../constants/theme';

const stats = [
  { value: '4+', label: 'Years Experience' },
  { value: '3',  label: 'IEEE Publications' },
  { value: '6',  label: 'AI Domains' },
  { value: '6+', label: 'Clients Served' },
];

export default function Stats({ statsVisible }) {
  return (
    <section id="stats-section" className="py-16" style={{ backgroundColor: theme.primary, color: theme.bg }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-[rgba(251,251,245,0.2)] overflow-hidden">
        {stats.map((stat, i) => (
          <div
            key={stat.label}
            className={`text-center flex flex-col items-center justify-center ${statsVisible ? 'stat-animate' : 'opacity-0'}`}
            style={{ animationDelay: `${(i + 1) * 0.1}s` }}
          >
            <div className="text-4xl md:text-5xl font-retropix mb-3">{stat.value}</div>
            <div className="text-xs md:text-sm font-bold uppercase tracking-widest opacity-90 max-w-[120px]">
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
